export default __webpack_public_path__ + "static/media/p4.6aba0b9e.jpg";